import find from "lodash/find";
import flatMap from "lodash/flatMap";
import forEach from "lodash/forEach";
import xor from "lodash/xor";
export default (sourceIds, currentMapData, newMapData) => {
    const ids = new Set(sourceIds);
    let nameUpdated = false;
    let colorUpdated = false;
    let pointsCoordsUpdated = false;
    forEach(currentMapData === null || currentMapData === void 0 ? void 0 : currentMapData.Geometry, g => {
        if (!g.Id || !ids.has(g.Id))
            return true;
        const geometryUndoData = find(newMapData, d => (d === null || d === void 0 ? void 0 : d.Id) === g.Id);
        if (geometryUndoData && geometryUndoData.Name !== g.Name)
            nameUpdated = true;
        if (geometryUndoData && geometryUndoData.Color !== g.Color)
            colorUpdated = true;
        if (geometryUndoData && xor(flatMap(geometryUndoData.Points), flatMap(g.Points)).length > 0)
            pointsCoordsUpdated = true;
        if (colorUpdated && nameUpdated && pointsCoordsUpdated)
            return false;
        return true;
    });
    if (!colorUpdated) {
        forEach(currentMapData === null || currentMapData === void 0 ? void 0 : currentMapData.Points, p => {
            var _a, _b;
            if (!p.Id || !ids.has(p.Id))
                return true;
            const pointUndoData = find(newMapData, d => (d === null || d === void 0 ? void 0 : d.Id) === p.Id);
            if (pointUndoData && ((_a = pointUndoData.NodeSource) === null || _a === void 0 ? void 0 : _a.Color) !== ((_b = p.NodeSource) === null || _b === void 0 ? void 0 : _b.Color)) {
                colorUpdated = true;
                return false;
            }
            return true;
        });
    }
    return { colorUpdated, nameUpdated, pointsCoordsUpdated };
};
